import { Paper } from '@mui/material';
import { styled } from '@mui/system';

export const StyledPaper = styled(Paper)({
  padding: '10px 10px 10px 10px',
  backgroundColor: 'transparent',
  width: '100%',
});
